export const Data = [
  {
    type:"zh",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/jjfa/banner.jpg"
      },
      menuData:[
        {
          num : {
            type:"text",
            content:"1"
          },
          tital : {
            type:"text",
            content:"针对医院"
          },
          path: {
            type:"text",
            content:"dyy"
          },
        },
        {
          num : {
            type:"text",
            content:"2"
          },
          tital : {
            type:"text",
            content:"针对医生"
          },
          path: {
            type:"text",
            content:"dys"
          },
        },
        {
          num : {
            type:"text",
            content:"3"
          },
          tital : {
            type:"text",
            content:"针对患者"
          },
          path: {
            type:"text",
            content:"dhz"
          },
        }


      ],
      item:[
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"dyy",
          index:"1",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"针对医院",
            },
            text2:{
              type:"text",
              content:"提升医院/科室竞争力：打造激光治疗特色，使医院/科室在专业领域更具差异化优势，树立技术领先、学术领先的形象，提升医院/科室的学术地位。\n" +
"增加经济效益：口腔激光治疗具备专门的收费条目，且由于患者治疗接受度高，能够为医院/科室带来更多的经济收入。\n" +
"促进科研与教学：为开展相关的科研项目提供了更多的研究方向和实践基础，产出更多的科研成果。同时也有利于教学工作的开展，培养更多优秀的人才。\n" +
"优化治疗效果：口腔激光治疗的精准性和有效性有助于提高科室对各类口腔疾病的治疗水平，如激光辅助的口腔种植、牙周病治疗、根管治疗等为患者提供更优质的医疗服务，从而增加患者对医院/科室的信任和认可。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/jjfa/3left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }
        },
        {
          type:"boxleft", //boxleft boxrigth boxvideo
          path:"dys",
          index:"2",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"针对医生",
            },
            text2:{
              type:"text",
              content:"提升专业技能：掌握口腔激光技术，丰富了治疗手段，拓宽了医生的专业知识和技能领域，使其在专业领域更具竞争力。\n" +
                "增加发展机会：在学术交流和研究方面，口腔激光治疗是一个新兴领域。通过参与相关研究和发表学术成果，能够获得更多的晋升以及学术发展机会。\n" +
                "提高治疗效果：激光治疗的精准性和有效性有助于医生更好地处理病例，获得更满意的治疗结果。同时相比传统方法，激光治疗有时能更快速地完成部分操作，提高了医生的工作效率。\n" +
                "更安全的工作环境：铒激光相对传统涡轮手机能够减少98%的气溶胶产生，使医生的工作环境更加友好和安全。\n" +
                "增强患者满意度：良好的治疗效果和患者体验能够显著提高患者对医生的满意度和信任度，有助于建立良好的医患关系，提升医生的声誉。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/jjfa/1right.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        },
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"dhz",
          index:"3",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"针对患者",
            },
            text2:{
              type:"text",
              content:"更舒适的体验：相较于传统治疗方法可能引起的强烈疼痛和不适，口腔激光治疗通常能大幅减轻患者在治疗过程中的疼痛感，让患者更容易接受治疗。\n" +
                "减少肿胀和疼痛：在手术或治疗过程中，激光能够烧灼小血管、淋巴管和暴露的神经末梢，从而降低术后肿胀和疼痛的程度。意味着患者术后的恢复更加顺利，不适感也相对较少。\n" +
                "缩短康复周期：由于激光对组织的损伤较小，能够刺激细胞的修复和再生，患者可以更快地恢复正常的口腔功能，减少因治疗对生活和工作的影响。\n" +
                "降低感染几率：激光的杀菌作用有助于清除病原体，创造一个相对清洁的治疗环境，从而显著降低感染的风险，并能够减少抗生素的使用。\n" +
                "改善美观效果：在一些涉及口腔美容的治疗中，如牙龈修整、牙龈脱色等，激光能够提供更精细、自然的效果，满足患者对美观的需求。",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/jjfa/2left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        }
      ],
      homeLeave:{
        text1:{
          type:"",
          content:"留言反馈"
        },
        text2:{
          type:"",
          content:"为您提供咨询服务，与您一起提升口腔激光医学水平"
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"姓名",
        text2:"您的手机号",
        text3:"您的微信",
        text4:"留下您的建议和意见",
        commit:"提交"
      }
    }

  },
  {
    type:"en",
    content: {
      boxImg:{
        type:"img",
        urlData:"http://116.62.38.250//image/ykb/nr/jjfa/banner.jpg"
      },
      menuData:[
        {
          num : {
            type:"text",
            content:"1"
          },
          tital : {
            type:"text",
            content:"For Hospitals"
          },
          path: {
            type:"text",
            content:"dyy"
          },
        },
        {
          num : {
            type:"text",
            content:"2"
          },
          tital : {
            type:"text",
            content:"For Doctors"
          },
          path: {
            type:"text",
            content:"dys"
          },
        },
        {
          num : {
            type:"text",
            content:"3"
          },
          tital : {
            type:"text",
            content:"For Patients"
          },
          path: {
            type:"text",
            content:"dhz"
          },
        }


      ],
      item:[
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"dyy",
          index:"1",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"For Hospitals",
            },
            text2:{
              type:"text",
              content:"For Hospitals Enhancing the Competitiveness of Hospitals/Departments: By creating unique features in laser treatment, hospitals/departments can gain a more differentiated edge in professional fields, establish an image of technological and academic leadership, and elevate their academic status. Increasing Economic Benefits: Oral laser treatment has specific billing items, and due to its high acceptance rate among patients, it can bring more economic income to hospitals/departments. Promoting Scientific Research and Teaching: It provides more research directions and practical foundations for conducting relevant scientific research projects, generating more scientific research achievements. At the same of time, it is also beneficial to the development of teaching work, cultivating more outstanding talents. Optimizing Treatment Effects: The precision and effectiveness of oral laser treatment help improve the treatment level of various oral diseases in departments, such as laser-assisted oral implantation, periodontal disease treatment, root canal treatment, etc., providing patients with higher-quality medical services and thus increasing patients' trust and recognition of hospitals/departments.",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/jjfa/3left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }
        },
        {
          type:"boxleft", //boxleft boxrigth boxvideo
          path:"dys",
          index:"2",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"For Doctors",
            },
            text2:{
              type:"text",
              content:"For Doctors Enhancing Professional Skills: Mastering oral laser technology enriches treatment methods and broadens doctors' professional knowledge and skill scope, making them more competitive in the professional field. Increasing Development Opportunities: Oral laser treatment is an emerging field in academic exchanges and research. By participating in relevant research and publishing academic achievements, doctors can obtain more opportunities for promotion and academic development. Improving Treatment Effects: The precision and effectiveness of laser treatment help doctors handle cases better and achieve more satisfactory treatment results. At the same time, compared with traditional methods, laser treatment can sometimes complete some operations more quickly, improving doctors' work efficiency. Safer Working Environment: The erbium laser can reduce the generation of aerosols by 98% compared with traditional turbine handpieces, creating a more friendly and safe working environment for doctors. Enhancing Patient Satisfaction: Good treatment effects and patient experiences can significantly improve patients' satisfaction and trust in doctors, which helps establish a good doctor-patient relationship and enhances doctors' reputation.",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/jjfa/1right.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        },
        {
          type:"boxrigth", //boxleft boxrigth boxvideo
          path:"dhz",
          index:"3",
          showData:false,
          content:{
            text1:{
              type:"text",
              content:"For Patients",
            },
            text2:{
              type:"text",
              content:"For Patients More Comfortable Experience: Compared with the intense pain and discomfort that traditional treatment methods may cause, oral laser treatment can usually greatly reduce patients' pain during the treatment process, making it easier for patients to accept the treatment. Reduced Swelling and Pain: During the operation or treatment, the laser can cauterize small blood vessels, lymphatic vessels, and exposed nerve endings, thereby reducing the degree of postoperative swelling and pain. This means that patients' postoperative recovery is smoother and they experience relatively less discomfort. Shortened Recovery Period: Since the laser causes less damage to tissues and can stimulate cell repair and regeneration, patients can regain normal oral functions more quickly, minimizing the impact of the treatment on their lives and work. Lowered Risk of Infection: The bactericidal effect of the laser helps to eliminate pathogens, creating a relatively clean treatment environment, thus significantly reducing the risk of infection and enabling a reduction in the use of antibiotics. Improved Aesthetic Effects: In some oral aesthetic treatments, such as gingival reshaping and gingival depigmentation, the laser can provide more delicate and natural results, meeting patients' aesthetic needs.",
            },
            text3:{
              type:"img",
              content:"http://116.62.38.250//image/ykb/nr/jjfa/2left.jpg",
            },
            text4:{
              type:"video",
              content:"",
            }
          }

        }
      ],
      homeLeave:{
        text1:{
          type:"",
          content:"Message and Feedback"
        },
        text2:{
          type:"",
          content:"We provide you with consultation services and work together with you to enhance the level of oral laser medicine."
        },
        text3:{
          type:"",
          content:"400-178-1617"
        },
        text4:{
          type:"",
          content:"info@yacobon.com"
        }
      },
      homeLeavePlace:{
        text1:"Name",
        text2:"Mobile Phone Number",
        text3:"WeChat ID",
        text4:"Please leave your suggestions and opinions.",
        commit:"Submit"
      }
    }

  },
];



// WEBPACK FOOTER //
// ./src/components/js/solution.js